export default __webpack_public_path__ + "static/media/330_business05-it-mobile.54107904.png";